export default __webpack_public_path__ + "media/images/home/slide_primary_2025_sm-08368c07740b41ec4397944eb7fa77c8.jpg";